import { api } from "@/lib/api-client";

export interface NamedChainRow {
  id: string;
  tenantId: string;
  name: string;
  description: string;
  steps: Array<{ type: string; config: Record<string, unknown> }>;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  usageCount?: number;
}

export interface NamedChainVersionRow {
  id: string;
  namedChainId: string;
  steps: Array<{ type: string; config: Record<string, unknown> }>;
  editedBy: string;
  editedAt: string;
}

export interface ChainReference {
  mappingId: string;
  destinationId: string;
  targetColumn: string;
}

export const namedChainsApi = {
  list: () => api.get<{ chains: NamedChainRow[] }>("/named-chains"),
  get: (id: string) => api.get<NamedChainRow>(`/named-chains/${id}`),
  getById: (id: string) => api.get<NamedChainRow>(`/named-chains/${id}`),
  create: (body: { name: string; description?: string; steps?: NamedChainRow["steps"] }) =>
    api.post<NamedChainRow>("/named-chains", body),
  update: (
    id: string,
    body: { name?: string; description?: string; steps?: NamedChainRow["steps"] },
  ) => api.put<NamedChainRow>(`/named-chains/${id}`, body),
  remove: (id: string) => api.delete(`/named-chains/${id}`),
  versions: (id: string) =>
    api.get<{ versions: NamedChainVersionRow[] }>(`/named-chains/${id}/versions`),
  rollback: (id: string, versionId: string) =>
    api.post<NamedChainRow>(`/named-chains/${id}/rollback`, { versionId }),
  usage: (id: string) =>
    api.get<{ references: ChainReference[] }>(`/named-chains/${id}/usage`),
};
